import { type CanvasHTMLElement } from '@canvas/input-types/base-event-types';

export const setupIgnoredEvents = (root: CanvasHTMLElement): (() => void) => {
  const preventDefault = (evt: Event) => evt.preventDefault();

  root.addEventListener('dragstart', preventDefault);

  return () => {
    root.removeEventListener('dragstart', preventDefault);
  };
};
